import React, { useState, useEffect, useContext } from 'react';
import { HeaderInfo } from './HeaderInfo';
import { FooterInfo } from './FooterInfo';
import { Col, Form, Checkbox, Button, Input, Radio, DatePicker, Row, Select, Typography, Spin } from 'antd';
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import { Context } from '../../components/context';
import dayjs from 'dayjs';
import { StringRegex, NumberRegex, DateConstraint, DateConstraintFechaIngreso } from '../../support/Utiles';

import { getCountries, getNationalities, getStates } from '../../components/utiles/DataForCombos';
import HttpService, { history, HttpServiceHandler } from '../../support/HttpService';

const { Option } = Select;
const { Title } = Typography;

//const nationalities = getNationalities();


//session storage para controlar el comportamiento del boton de regreso
sessionStorage.setItem("isBrowserBackButtonPressed", "false");

function Step1() {
    return (
        <>
            <HeaderInfo />
            <FormGroup />
            <FooterInfo />
        </>
    );

}





function FormGroup() {

    history.navigate = useNavigate();
    const [form] = Form.useForm();

    const [checked, setChecked] = useState(false);
    const [radioValue, setRadioValue] = useState(false);
    const [showPartnerForm, setShowPartnerForm] = useState(false);
    const [localityStatus, setLocalityStatus] = useState(true);
    const [employeerType, setEmployeerType] = useState('Empresa');
    const [zipCode, setZipCode] = useState(null);

    const [form1Data, setForm1Data] = useState(null);

    const location = useLocation();

    const [loading, setLoading] = useState(false);

    HttpServiceHandler.setLoading = setLoading;

    const { states, setStates, countries, nationalities, setCountries, setNationalities, basePath } = useContext(Context);

    useEffect(() => {
        setTimeout(() => {

            //Asignar el basePath aquí, basado en un localStorage o lectura de algún archivo.
            //setBasePath('/alta1a1')
            //con esto es suficiente, en el segundo paso tendrá el valor actualizado.

            HttpService.get(basePath + '/api/states', { params: { countryCode: process.env.REACT_APP_COUNTRY_CODE } })
                .then(response => {

                    setStates(response.data.content);

                    HttpService.get(basePath + '/api/countries')
                        .then(response => {
                            setCountries(response.data.content);
                            setNationalities(response.data.content2);
                        })
                        .catch(error => {                            
                            setCountries(getCountries());
                            setNationalities(getNationalities());
                        })

                })
                .catch(error => {                    
                    setStates(getStates());
                    setCountries(getCountries());
                    setNationalities(getNationalities());
                })
            console.log(basePath);
            // setLoading(false);
        }, 2000);
    }, [basePath])


    useState(() => {
        if (location.state !== null) {
            setChecked((location.state.checkbox === 'on'));

            setZipCode(location.state.codPostal);
            setEmployeerType(location.state.tipoEntidad);
        }
    })

    const onCheckboxChange = async e => {
        await setChecked(e.target.checked)
        form.validateFields(["condiciones"])
    }

    const onRadioChange = async e => {
        await setRadioValue(e.target.value)
        form.validateFields(["sexo"])
    }

    const onRadioEmployeerTypeChange = async e => {
        await setEmployeerType(e.target.value)
    }

    const onZipCodeChange = async (value) => {
        setZipCode(value.target.value)
    }

    const zipCodeValidation = (rule, value, callback) => {

        if (localityStatus) {
            const minValue = 11000;
            const maxValue = 13000;

            if (zipCode >= minValue && zipCode <= maxValue) {
                return callback()
            } else {
                return callback("Por favor, escribe un valor entre 11000 y 13000.");
            }
        }
        else {
            return callback();
        }
    }

    const submit = async e => {
        e.preventDefault();
        try {
            const values = await form.validateFields()                        
            values.condiciones = (values.condiciones == 'on') ? 'A' : null;
            values.paisNacimiento = form.getFieldValue('paisNacimiento');
            values.nacionalidad = form.getFieldValue('nacionalidad');
            values.departamentoEmpleador = form.getFieldValue('departamentoEmpleador');
            
            values.codDpto = form.getFieldValue('depto');
            values.depto = states.filter(item => item.value == values.codDpto)[0].label;            

            values.tipoEntidad = values.tipoEntidad.toUpperCase();

            if(showPartnerForm){
                values.paisDocumentoConyuge = "858";
                values.tipoDocumentoConyuge = "IDE";
            }                        

            setForm1Data(values);

        } catch (errorInfo) {
            console.log("Failed:", errorInfo)
        }
    }

    const validation = (rule, value, callback) => {
        if (checked) {
            return callback()
        }
        return callback("Debe aceptar las condiciones para continuar")
    }

    const radiovalidation = (rule, value, callback) => {
        if (radioValue || location.state ) {
            return callback()
        }
        return callback("Este campo es obligatorio.")
    }

    const civalidation = (value) => {
        var ci = value.replace(/\D/g, '');
        var dig = Number(ci[ci.length - 1]);
        ci = ci.replace(/[0-9]$/, '');
        var nrodig = 0;
        var a = 0; var i = 0;
        if (ci.length <= 6) {
            for (i = ci.length; i < 7; i++) {
                ci = '0' + ci;
            }
        }

        for (i = 0; i < 7; i++) {
            a += (parseInt("2987634"[i]) * parseInt(ci[i])) % 10;
        }

        if (a % 10 === 0) {
            nrodig = 0;
        } else {
            nrodig = 10 - a % 10;
        }
        return (dig === nrodig /*&& parseInt(largo)<8*/ && parseInt(ci) < 9999999);
    }

    const manageMaritalStatus = async e => {        
        if (e == 'C' || e == 'U') {
            setShowPartnerForm(true);
        }
        else {
            setShowPartnerForm(false);            
        }                
    }

    const onDepartmentChange = e => {        
        if (e != 1) {
            setLocalityStatus(false);
            form.setFieldValue("localidad", "");
        }
        else {
            setLocalityStatus(true);
            form.setFieldValue("localidad", "MONTEVIDEO"); 
        }
    }

    const valuesToUpperCase = (value) => (value ? value.toUpperCase() : '');

    const getForm1Fields = () => {
        const children = [];

        children.push(
            <Col xs={30} sm={150} md={20} lg={12} key={0}>
                {/* <span class="textos">(Sin puntos ni guiones. Incluya el dígito verificador)</span> */}
                <Form.Item
                    name={'numeroDocumento'}
                    label={'Número de documento'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.numeroDocumento
                        :
                        null
                    }
                    rules={[
                        {
                            validator: (_, value) => {
                                if (civalidation(value.toString())) {
                                    return Promise.resolve();
                                } else {
                                    return Promise.reject('Some message here');
                                }
                            },
                            message: 'Ingrese una cédula válida'
                        },                        
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        },
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        }
                    ]}
                >
                    <Input placeholder="NÚMERO DE DOCUMENTO" />
                </Form.Item>

                <Form.Item
                    name={'nombre'}
                    label={'Primer nombre'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.nombre
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="PRIMER nombre" />
                </Form.Item>

                <Form.Item
                    name={'segundoNombre'}
                    label={'Segundo nombre'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.segundoNombre
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="SEGUNDO nombre" />
                </Form.Item>

                <Form.Item
                    name={'apellido'}
                    label={'Primer apellido'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.apellido
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="PRIMER APELLIDO" />
                </Form.Item>

                <Form.Item
                    name={'apellidoMaterno'}
                    label={'Segundo apellido'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.segundoApellido
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="SEGUNDO APELLIDO" />
                </Form.Item>

                <Form.Item
                    name={'sexo'}
                    label={'Sexo'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.sexo
                        :
                        null
                    }
                    rules={[
                        { validator: radiovalidation },                        
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        }
                    ]}
                >
                    <Radio.Group onChange={onRadioChange}>
                        <Radio value={'F'}>Femenino</Radio>
                        <Radio value={'M'}>Masculino</Radio>
                    </Radio.Group>
                </Form.Item>

            </Col>,
        );
        children.push(
            <Col xs={30} sm={150} md={20} lg={12} key={1}>
                <Form.Item
                    name={'paisNacimiento'}
                    label={'País de nacimiento'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.paisNacimiento
                        :
                        858
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                >
                    <Select
                        options={countries}
                    // defaultValue={}                  
                    />

                </Form.Item>

                <Form.Item
                    name={'nacionalidad'}
                    label={'Nacionalidad'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.nacionalidad
                        :
                        'URUGUAYO'
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                >
                    <Select
                        options={nationalities}
                    />
                </Form.Item>

                <Form.Item
                    label="Fecha nacimiento"
                    name="fechaNacimiento"
                    initialValue={location.state ?
                        dayjs(dayjs(location.state.fechaNacimiento.$d.toString()).format('YYYY/M/D'), 'YYYY/M/D')
                        :
                        dayjs(dayjs("2008/12/01").format('YYYY/M/D'), 'YYYY/M/D')
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                >
                    <DatePicker disabledDate={DateConstraint} />
                </Form.Item>

                <Form.Item
                    name={'estadoCivil'}
                    label={'Estado civil'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.estadoCivil
                        :
                        "S"
                    }
                >
                    <Select onChange={manageMaritalStatus}>
                        <Option value="S">Soltero</Option>
                        <Option value="C">Casado</Option>
                        <Option value="V">Viudo</Option>
                        <Option value="D">Divorciado</Option>
                        <Option value="U">Unión Libre</Option>
                        <Option value="X">Otro</Option>
                    </Select>
                </Form.Item>
            </Col>,
        );

        return children;
    };

    const getForm2Fields = () => {

        const children = [];
        children.push(
            <Col xs={30} sm={150} md={20} lg={12} key={2}>

                <Form.Item
                    label={'País'}
                >
                    <Input value={'URUGUAY'} disabled />
                </Form.Item>

                <Form.Item                    
                    name={'depto'}
                    label={'Departamento'}
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                    initialValue={location.state ?
                        location.state.depto
                        :
                        '1'
                    }                
                >
                    <Select
                        options={states}
                        onChange={onDepartmentChange}                                                
                    />                        
                </Form.Item>

                <Form.Item
                    name={'localidad'}
                    label={'Localidad'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        (location.state.localidad) ? location.state.localidad : null
                        :
                        "MONTEVIDEO"
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                >
                    <Input disabled={localityStatus} />
                </Form.Item>

                <Form.Item
                    name={'calle'}
                    label={'Dirección'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.calle
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        }
                    ]}
                >
                    <Input placeholder='DIRECCIÓN' />
                </Form.Item>

                <Form.Item
                    name={'nroPuerta'}
                    label={' '}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.nroPuerta
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input className='numero' placeholder='NÚMERO' />
                </Form.Item>

                <Form.Item
                    name={'apartamento'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.apartamento
                        :
                        null
                    }
                    rules={[                        
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input className='numero' placeholder='APTO.' />
                </Form.Item>

                <Form.Item
                    name={'codPostal'}
                    normalize={valuesToUpperCase}
                    label={'Código postal'}                    
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            validator: zipCodeValidation
                        }
                    ]}
                >
                    <Input
                        placeholder='CÓDIGO POSTAL'
                        onChange={onZipCodeChange}                        
                    />
                </Form.Item>
            </Col>,
        );

        children.push(

            <Col xs={30} sm={150} md={20} lg={12} key={3}>

                <Form.Item
                    name={'telefono'}
                    label={'Teléfono'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.telefono
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder='TELÉFONO' />
                </Form.Item>

                <Form.Item
                    name={'celular'}
                    label={'Celular'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state ?
                        location.state.celular
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder='celular' />
                </Form.Item>

                <Form.Item
                    name={'email'}
                    label={'Correo electrónico'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.email
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(/.+@.+\..+/),
                            message: "Ingrese un correo válido"
                        }]}
                >
                    <Input placeholder='CORREO ELECTRONICO' />
                </Form.Item>


            </Col>

        );

        return children;
    }

    const getPartnerFields = () => {
        const children = [];
        children.push(

            <Col xs={30} sm={150} md={20} lg={12} key={4}>

                <Form.Item
                    name={'nombreConyuge'}
                    label={'Primer nombre cónyuge'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.nombreConyuge
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder='PRIMER nombre DEL CÓNYUGE' />
                </Form.Item>

                <Form.Item
                    name={'segundoNombreConyuge'}
                    label={'Segundo nombre cónyuge'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.segundoNombreConyuge
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder='SEGUNDO nombre DEL CÓNYUGE' />
                </Form.Item>

                <Form.Item
                    name={'apellidoConyuge'}
                    label={'Primer apellido cónyuge'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.apellidoConyuge
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder='PRIMER APELLIDO DEL CÓNYUGE' />
                </Form.Item>

                <Form.Item
                    name={'apellidoMaternoConyuge'}
                    label={'Segundo apellido cónyuge'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.apellidoMaternoConyuge
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder='SEGUNDO APELLIDO DEL CÓNYUGE' />
                </Form.Item>


            </Col>

        );

        children.push(

            <Col xs={30} sm={150} md={20} lg={12} key={5}>

                <Form.Item
                    name={'tdocC'}
                    label={'Tipo documento cónyuge'}
                    normalize={valuesToUpperCase}
                    initialValue="CI"
                >
                    <Select>
                        <Option value="CI">CI</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name={'numeroDocumentoConyuge'}
                    label={'Número documento cónyuge'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.numeroDocumentoConyuge
                        :
                        null
                    }
                    rules={[
                        {
                            validator: (_, value) => {
                                if (civalidation(value.toString())) {
                                    return Promise.resolve();
                                } else {
                                    return Promise.reject('Some message here');
                                }
                            },
                            message: 'Ingrese una cédula válida'
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder="NÚMERO DE DOCUMENTO CÓNYUGE" />
                </Form.Item>

                <Form.Item
                    label="Fecha de nacimiento cónyuge"
                    name="fechaNacimientoConyuge"
                    initialValue={location.state  ?
                        dayjs(location.state.fechaNacimientoConyuge.$d, 'YYYY/MM/DD')
                        :
                        dayjs(dayjs("2008/12/01").format('YYYY/M/D'), 'YYYY/M/D')
                    }
                >
                    <DatePicker disabledDate={DateConstraint} />
                </Form.Item>

            </Col>
        );

        return children;
    }

    const getCompanyDataCompanyBased = () => {

        const children = [];

        children.push(
            <Col xs={30} sm={150} md={20} lg={12} key={6}>

                <Form.Item
                    name={'rut'}
                    label={'RUT empleador'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.rut
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder="RUT EMPLEADOR" />
                </Form.Item>

                <Form.Item
                    name={'denominacionEmpleador'}
                    label={'Denominación social del empleador'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.denominacionEmpleador
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="DENOMINACIÓN SOCIAL DEL EMPLEADOR" />
                </Form.Item>

                <Form.Item
                    name={'nombreFantasia'}
                    label={'Nombre fantasía del empleador'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.nombreFantasia
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="nombre FANTASÍA DEL EMPLEADOR" />
                </Form.Item>

                <Form.Item
                    name={'sueldoLiquido'}
                    label={'Sueldo líquido declarado ($)'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.sueldoLiquido
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder="SUELDO LIQUIDO DECLARADO" />
                </Form.Item>

            </Col>
        );
        return children;
    }

    const getCompanyDataParticularBased = () => {

        const children = [];

        children.push(
            <Col xs={30} sm={150} md={20} lg={12} key={7}>

                <Form.Item
                    name={'nroBPS'}
                    label={'BPS'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.nroBPS
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder="RUT EMPLEADOR" />
                </Form.Item>

                <Form.Item
                    name={'nombreParticular'}
                    label={'Nombre particular'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.nombreParticular
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="DENOMINACIÓN SOCIAL DEL EMPLEADOR" />
                </Form.Item>

                <Form.Item
                    name={'sueldoLiquido'}
                    label={'Sueldo líquido declarado ($)'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.sueldoLiquido
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input placeholder="SUELDO LIQUIDO DECLARADO" />
                </Form.Item>

            </Col>
        );
        return children;
    }

    const getCompanyData = () => {
        const children = [];

        children.push(
            <Col xs={30} sm={150} md={20} lg={12} key={8}>
                <Form.Item
                    name={'sectorDeActividad'}
                    label={'Sector de actividad empleador'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.sectorDeActividad
                        :
                        null
                    }
                    rules={[
                        {
                            pattern: new RegExp(StringRegex()),
                            message: "Ingrese sólo letras"
                        }
                    ]}
                >
                    <Input placeholder="DENOMINACIÓN SOCIAL DEL EMPLEADOR" />
                </Form.Item>

                <Form.Item
                    name={'departamentoEmpleador'}
                    label={'Departamento'}
                    normalize={valuesToUpperCase}
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                    initialValue={location.state  ?
                        location.state.departamentoEmpleador
                        :
                        '1'
                    }
                >
                    <Select
                        options={states}
                    />
                </Form.Item>

                <Form.Item
                    name={'domicilioEmpleador'}
                    label={'Domicilio del empleador'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.domicilioEmpleador
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        }
                    ]}
                >
                    <Input placeholder='DIRECCIÓN' />
                </Form.Item>

                <Form.Item
                    name={'domicilioNroEmpleador'}
                    label={' '}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.domicilioNroEmpleador
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio.',
                        },
                        {
                            pattern: new RegExp(NumberRegex()),
                            message: "Ingrese sólo números"
                        }
                    ]}
                >
                    <Input className='numero' placeholder='NÚMERO' />
                </Form.Item>

                <Form.Item
                    name={'domicilioAptoEmpleador'}
                    normalize={valuesToUpperCase}
                    initialValue={location.state  ?
                        location.state.domicilioAptoEmpleador
                        :
                        null
                    }
                >
                    <Input className='numero' placeholder='APTO.' />
                </Form.Item>

                <Form.Item
                    label={'Fecha de ingreso'}
                    name="fechaIngreso"
                    initialValue={location.state  ?
                        dayjs(dayjs(location.state.fechaIngreso.$d.toString()).format('YYYY/M/D'), 'YYYY/M/D')
                        :
                        null
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Este campo es obligatorio',
                        },
                    ]}
                >
                    <DatePicker disabledDate={DateConstraintFechaIngreso} />
                </Form.Item>

            </Col>
        );
        return children;
    }

    return (
        <>
            {/* <Spin tip="Loading..." spinning={loading}> */}

                <Form colon={false} className='form' form={form}>
                    <div className="contenedorCondiciones">
                        <Form.Item
                            name="condiciones"
                            rules={[{ validator: validation }]}>
                            <label htmlFor="condiciones">Acepto <Checkbox checked={checked} onChange={onCheckboxChange}></Checkbox></label>
                        </Form.Item>
                    </div>

                    <Title className='titleForm' level={5}>Datos Personales del Titular</Title>

                    <Row gutter={24}>{getForm1Fields()}</Row>

                    <Title className='titleForm' level={5}>Domicilio del Titular en Uruguay</Title>

                    <Row gutter={24}>{getForm2Fields()}</Row>

                    {showPartnerForm ?

                        <Title className='titleForm' level={5}>Datos Personales del Cónyuge</Title>
                        :
                        null
                    }

                    {showPartnerForm ?

                        <Row gutter={24}>{getPartnerFields()}</Row>
                        :
                        null
                    }

                    <Title className='titleForm' level={5}>Datos de la Empresa donde trabaja</Title>
                    <Row gutter={24}>
                        <Col xs={30} sm={150} md={20} lg={12} key={2}>
                            <Form.Item
                                name={'tipoEntidad'}
                                label={'Tipo de entidad empleador'}
                                initialValue={employeerType}
                            >
                                <Radio.Group onChange={onRadioEmployeerTypeChange}>
                                    <Radio value={'Empresa'}>Empresa</Radio>
                                    <Radio value={'Particular'}>Particular</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>


                    {employeerType === 'Empresa' ?
                        <Row gutter={24}>{getCompanyDataCompanyBased().concat(getCompanyData())}</Row>
                        :
                        <Row gutter={24}>{getCompanyDataParticularBased().concat(getCompanyData())}</Row>
                    }


                    <Form.Item>
                        <Button htmlType='submit' danger type="primary" onClick={submit}>
                            Siguiente
                        </Button>
                    </Form.Item>

                </Form>

                {form1Data && <Navigate to="/alta1a1/step2" state={form1Data} replace={true} />}

            {/* </Spin> */}
        </>
    );
}

export { Step1 }